import { render, staticRenderFns } from "./AssignRoleModal.vue?vue&type=template&id=18ccef47&scoped=true"
import script from "./AssignRoleModal.vue?vue&type=script&lang=js"
export * from "./AssignRoleModal.vue?vue&type=script&lang=js"
import style0 from "./AssignRoleModal.vue?vue&type=style&index=0&id=18ccef47&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ccef47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ccef47')) {
      api.createRecord('18ccef47', component.options)
    } else {
      api.reload('18ccef47', component.options)
    }
    module.hot.accept("./AssignRoleModal.vue?vue&type=template&id=18ccef47&scoped=true", function () {
      api.rerender('18ccef47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/system/components/Modal/AssignRoleModal.vue"
export default component.exports